import * as React from 'react';
import React__default, { useState } from 'react';
import emotionStyled from '@emotion/styled';
import { Flex, Box } from '@ssg-b2b/theme-tools';
import { useTheme } from 'emotion-theming';
import { noop } from '@ssg-b2b/utils';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const styled = emotionStyled;

var TeamBadgeType;
(function (TeamBadgeType) {
    TeamBadgeType["Primary"] = "primary";
    TeamBadgeType["Secondary"] = "secondary";
    TeamBadgeType["Selected"] = "selected";
    TeamBadgeType["Transparent"] = "transparent";
})(TeamBadgeType || (TeamBadgeType = {}));

const TeamBadgeContainer = styled(Flex) `
    box-sizing: border-box;
    background-color: ${(props) => props.type === TeamBadgeType.Transparent
    ? "transparent"
    : props.theme.teamBadge.types[props.type].backgroundColor};
    border: 2px solid
        ${(props) => props.type === TeamBadgeType.Transparent
    ? "transparent"
    : props.theme.teamBadge.types[props.type].borderColor};
    border-radius: ${(props) => (props.type === TeamBadgeType.Transparent ? "unset" : "50%")};
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
`;
const ImageWrapper = styled(Box) `
    cursor: ${(props) => (props.clickable ? "pointer" : "unset")};
`;
const Image = styled.img `
    display: block;
    width: inherit;
    height: inherit;
    transform: scale(${(props) => props.imageToWrapperRatio});
`;

var TeamBadgeSize;
(function (TeamBadgeSize) {
    TeamBadgeSize["SM"] = "24px";
    TeamBadgeSize["MD"] = "34px";
    TeamBadgeSize["LG"] = "48px";
    TeamBadgeSize["XL"] = "68px";
    TeamBadgeSize["FitToContainer"] = "100%";
})(TeamBadgeSize || (TeamBadgeSize = {}));

var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgDefaultBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 202,
    viewBox: "0 0 172 202",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.7%",
    y: "-3.1%",
    width: "107.3%",
    height: "106.2%",
    filterUnits: "objectBoundingBox",
    id: "DefaultBadge_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.246 0c35.61 18.426 59.42 42.029 71.426 70.81 12.007 28.781 13.545 65.933 4.613 111.455C124.49 190.088 99.144 194 82.246 194c-16.897 0-42.243-3.912-76.038-11.735-9.841-41.8-7.982-78.952 5.578-111.455S48.833 14.703 82.246 0z",
    id: "DefaultBadge_svg__b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-180 84 99)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#DefaultBadge_svg__a)",
    xlinkHref: "#DefaultBadge_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 11,
    d: "M82.062 6.114c-30.855 14.198-52.516 36.41-65.2 66.814-12.73 30.515-14.782 65.387-6.06 104.748C42.545 184.899 66.41 188.5 82.245 188.5c15.814 0 39.633-3.59 71.31-10.793 7.985-42.934 6.274-77.852-4.96-104.78-11.21-26.87-33.31-49.14-66.534-66.813z",
    strokeLinejoin: "square",
    fill: "#ED1C24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.754 198c.164-129.333.164-194 0-194 12.502 0 37.848 3.912 76.038 11.735 9.841 41.8 7.982 78.952-5.578 111.455s-37.047 56.107-70.46 70.81z",
    fillOpacity: 0.1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.938 191.886c30.855-14.198 52.516-36.41 65.2-66.814 12.73-30.515 14.782-65.387 6.06-104.748C125.455 13.101 101.59 9.5 85.755 9.5c-15.814 0-39.633 3.59-71.31 10.793-7.985 42.934-6.274 77.852 4.96 104.78 11.21 26.87 33.31 49.14 66.534 66.813z",
    stroke: "#FFF",
    strokeWidth: 11
  }))));
}

const DefaultTeamBadge = ({ imageToWrapperRatio }) => {
    const { teamBadge: { defaultBadge } } = useTheme();
    const { src, Component } = defaultBadge || {};
    if (!!Component)
        return Component;
    else if (!!src)
        return (React__default.createElement(Image, { imageToWrapperRatio: imageToWrapperRatio, src: src, alt: "Default team badge" }));
    else
        return (React__default.createElement(SvgDefaultBadge, { height: "inherit", width: "inherit", transform: `scale(${imageToWrapperRatio})` }));
};

const TeamBadge = (_a) => {
    var { src, type = TeamBadgeType.Primary, size = TeamBadgeSize.FitToContainer, alt = "Team badge", onClick, imageToWrapperRatio = 4 / 5 } = _a, styledSystemProps = __rest(_a, ["src", "type", "size", "alt", "onClick", "imageToWrapperRatio"]);
    const [imageError, setImageError] = useState(false);
    const handleImageError = () => setImageError(true);
    return (React__default.createElement(TeamBadgeContainer, Object.assign({ type: type, width: size, height: size }, styledSystemProps),
        React__default.createElement(ImageWrapper, { "data-testid": "team-badge-image-wrapper", width: size, height: size, clickable: !!onClick, onClick: onClick !== null && onClick !== void 0 ? onClick : noop }, !!src && !imageError ? (React__default.createElement(Image, { imageToWrapperRatio: imageToWrapperRatio, src: src, onError: handleImageError, alt: alt })) : (React__default.createElement(DefaultTeamBadge, { imageToWrapperRatio: imageToWrapperRatio })))));
};

export { TeamBadge, TeamBadgeSize, TeamBadgeType };
